'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var NOTIFICATION_FILLED = 'M17.988 15.4649L20 17.3247V18.2325H4V17.3247L6.01198 15.4649V10.8819C6.01198 9.43542 6.40319 8.1882 7.18563 7.14022C7.98404 6.06273 9.09381 5.36163 10.515 5.0369V4.39483C10.515 4.01107 10.6587 3.68266 10.9461 3.40959C11.2335 3.13653 11.5848 3 12 3C12.4152 3 12.7705 3.13653 13.0659 3.40959C13.3613 3.68266 13.509 4.01107 13.509 4.39483V5.0369C14.9142 5.36163 16.016 6.07011 16.8144 7.16236C17.5968 8.21034 17.988 9.45018 17.988 10.8819V15.4649ZM12 21C11.4411 21 10.9661 20.8229 10.5749 20.4686C10.1836 20.1144 9.98802 19.6863 9.98802 19.1845H14.012C14.012 19.6863 13.8124 20.1144 13.4132 20.4686C13.014 20.8229 12.5429 21 12 21Z';
var IconNotificationFilled = lib.variant('IconNotificationFilled', icon.Icon, {
    path: NOTIFICATION_FILLED,
});

exports.IconNotificationFilled = IconNotificationFilled;
//# sourceMappingURL=index-86289f8f.js.map
